var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.284 9.6c-0.64 0.394-1.329 0.64-2.068 0.788-0.591-0.64-1.428-1.034-2.363-1.034-1.772 0-3.249 1.477-3.249 3.298 0 0.246 0.049 0.492 0.098 0.738-2.708-0.148-5.071-1.477-6.695-3.446-0.295 0.492-0.443 1.083-0.443 1.674 0 1.132 0.591 2.166 1.428 2.757-0.542 0-1.034-0.148-1.477-0.394v0.049c0 1.625 1.132 2.954 2.609 3.249-0.295 0.098-0.542 0.098-0.837 0.098-0.197 0-0.394 0-0.591-0.049 0.394 1.329 1.625 2.265 3.003 2.314-1.132 0.886-2.511 1.428-4.037 1.428-0.246 0-0.542 0-0.788-0.049 1.428 0.935 3.151 1.477 4.972 1.477 5.957 0 9.206-5.071 9.206-9.452 0-0.148 0-0.295 0-0.443 0.64-0.492 1.181-1.034 1.625-1.723-0.591 0.246-1.181 0.443-1.871 0.542 0.689-0.394 1.231-1.083 1.477-1.822z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.c19da5fb201a17c7301f20d24fa19d03.svg";
export { ForwardRef as ReactComponent };